export enum UserInvoiceType {
	Saas = 'SAAS',
	Taas = 'TAAS',
	Both = 'BOTH',
 }
